import { Routes, Route, Navigate } from "react-router-dom";
import V2AttorneyLayout from "./layouts/AttorneyLayout";
import V2AdminLayout from "./layouts/AdminLayout";
import SettingsLayout from "./layouts/SettingsLayout";
import { useIsMobile } from "@/v2/hooks/useIsMobile";

// Pages
import Tracked from "./pages/Tracked";
import Exported from "./pages/Exported";
import Calendar from "./pages/CalendarPage";
import Support from "./pages/Support";
import FAQ from "./pages/FAQ";
import Updates from "./pages/Updates";
import Docs from "./pages/Docs";

// Settings pages
import SettingsIndex from "./pages/settings/SettingsIndex";
import Preferences from "./pages/settings/Preferences";
import Tracking from "./pages/settings/Tracking";
import RestrictedWords from "./pages/settings/RestrictedWords";
import Abbreviations from "./pages/settings/Abbreviations";

// Admin pages
import AdminDashboard from "./pages/admin/Dashboard";
import AdminBilling from "./pages/admin/Billing";
import AdminTimekeeper from "./pages/admin/Timekeeper";
import AdminSupport from "./pages/admin/Support";
import AdminUpdates from "./pages/admin/Updates";

interface V2RoutesProps {
	isAdmin: boolean;
}

export function V2Routes({ isAdmin }: V2RoutesProps) {
	const isMobile = useIsMobile();

	return (
		<Routes>
			<Route path="/" element={<Navigate to={isAdmin && !isMobile ? "/admin" : "/tracked"} replace />} />

			{/* Admin routes — hourglass:mobile:v0: blocked on mobile */}
			<Route
				path="/admin"
				element={isAdmin && !isMobile ? <V2AdminLayout /> : <Navigate to="/tracked" replace />}
			>
				<Route index element={<Navigate to="/admin/dashboard" replace />} />
				<Route path="dashboard" element={<AdminDashboard />} />
				<Route path="billing" element={<AdminBilling />} />
				<Route path="timekeeper" element={<AdminTimekeeper />} />
				<Route path="support" element={<AdminSupport />} />
				<Route path="updates" element={<AdminUpdates />} />
			</Route>

			{/* Settings routes (own layout) */}
			<Route path="/settings" element={<SettingsLayout />}>
				<Route index element={<SettingsIndex />} />
				<Route path="preferences" element={<Preferences />} />
				<Route path="tracking" element={<Tracking />} />
				<Route path="restricted-words" element={<RestrictedWords />} />
				<Route path="abbreviations" element={<Abbreviations />} />
			</Route>

			{/* Attorney routes */}
			<Route element={<V2AttorneyLayout />}>
				<Route path="/tracked" element={<Tracked />} />
				<Route path="/exported" element={<Exported />} />
				<Route path="/calendar" element={<Calendar />} />
				<Route path="/support" element={<Support />} />
				<Route path="/faq" element={<FAQ />} />
				<Route path="/updates" element={<Updates />} />
				<Route path="/docs" element={<Docs />} />
			</Route>
		</Routes>
	);
}
